import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const treasureBoxSlide = createSlice({
    name: "treasureBox",
    initialState: {
        page: 0,
        pageCount: 0,
        listData: null,

        success: false,
        fail: false,
        
        detailData: null,
        responseData: null,
        errorDetailData: null,
        summaryData: null,
    },
    reducers: {
        doGetTreasureBoxListSuccess: (state, action) => {
            state.listData = action.payload.data;
            state.page = action.payload?.current_page;
			state.pageCount = action.payload?.page_count;
        },
        doGetTreasureBoxListFail: (state, action) => {
            state.listData = null;
            state.page = 0;
			state.pageCount = 0;
        },

        doGetTreasureBoxSummarySuccess: (state, action) => {
            state.summaryData = action.payload?.data;
        },
        doGetTreasureBoxSummaryFail: (state, action) => {
            state.summaryData = null;
        },

        doGetTreasureBoxDetailSuccess: (state, action) => {
            state.detailData = action.payload.data;
        },
        doGetTreasureBoxDetailFail: (state, action) => {
            state.detailData = null;
        },

        doAddTreasureBoxSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
			state.responseData = action.payload;
        },
        doAddTreasureBoxFail: (state, action) => {
            state.success = false;
            state.fail = true;
			state.errorDetailData = action.payload;
        },

        doUpdateTreasureBoxSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
        },
        doUpdateTreasureBoxFail: (state, action) => {
            state.success = false;
            state.fail = true;
			state.errorDetailData = action.payload;
        },

        resetTreasureBoxStateSuccess: (state, action) => {
            state.success = action.payload;
            state.fail = action.payload;
			state.errorDetailData = null;
            state.assignSuccess = action.payload;
            state.assignFail = action.payload;
            state.assignReponseData = null;
            state.downloadQRSuccess = action.payload;
            state.downloadQRFail = action.payload;
        },

        resetTreasureBoxSuccess: (state, action) => {
            state.detailData = null;
        },
    },
});

export const doGetTreasureBoxList = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/treasure-box?page=${param.page}&size=${param.limit}`;
        if(param.filter) {
            url += `&filter=${encodeURIComponent(param.filter)}`;
        }

        const response = await axios.get(url);
        dispatch(doGetTreasureBoxListSuccess(response.data));
    } catch (error) {
        dispatch(doGetTreasureBoxListFail(error.response));
    }
};

export const doGetTreasureBoxSummary = () => async (dispatch) => {
    try {
        const token = localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.get(`/api/admin/treasure-box/summary`, config);
        dispatch(doGetTreasureBoxSummarySuccess(response.data));
    } catch (error) {
        dispatch(doGetTreasureBoxSummaryFail(error.response));
    }
};

export const doGetTreasureBoxDetail = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/treasure-box/${param.product_id}`;
       
        const response = await axios.get(url);
        dispatch(doGetTreasureBoxDetailSuccess(response.data));
    } catch (error) {
        dispatch(doGetTreasureBoxDetailFail(error.response));
    }
};

export const doAddTreasureBox = (param) => async (dispatch) => {
    try {
        const url = `/api/admin/treasure-box`;

        // Create FormData
        const formData = new FormData();

        // Add basic fields (name, sku, credit, stock_quantity, status)
        formData.append("name", param.name);
        formData.append("prize_name", param.prize_name);
        formData.append("prize_type", param.prize_type);
        formData.append("airtag_points_value", param.airtag_points_value);
        formData.append("status", param.status);

        // Handle product_images object
        const productImages = param.product_images;
        
        if (productImages && typeof productImages === "object") {
            // Handle new image files
            if (productImages.images && Array.isArray(productImages.images)) {
                productImages.images.forEach((image) => {
                    if (image instanceof File) {
                        formData.append("images", image);
                    }
                });
            }
        }

        // formData.append('quotation_data', JSON.stringify(quotationData));
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        const response = await axios.post(url, formData, config);
        dispatch(doAddTreasureBoxSuccess(response.data));
    } catch (error) {
        dispatch(doAddTreasureBoxFail(error.response));
    }
};

export const doUpdateTreasureBox = (param, treasure_box_id) => async (dispatch) => {
    try {
        const url = `/api/admin/treasure-box/${treasure_box_id}`;

        // Create FormData
        const formData = new FormData();

        // Add basic fields (name, sku, credit, stock_quantity, status)
        formData.append("name", param.name);
        formData.append("prize_name", param.prize_name);
        formData.append("prize_type", param.prize_type);
        formData.append("airtag_points_value", param.airtag_points_value);
        formData.append("status", param.status);

        // Handle product_images object
        const productImages = param.product_images;
        
        if (productImages && typeof productImages === "object") {
            // Handle new image files
            if (productImages.images && Array.isArray(productImages.images)) {
                productImages.images.forEach((image) => {
                    if (image instanceof File) {
                        formData.append("images", image);
                    } 
                });
            }
        }

        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        };

        const response = await axios.put(url, formData, config);
        dispatch(doUpdateTreasureBoxSuccess(response.data));
    } catch (error) {
        dispatch(doUpdateTreasureBoxFail(error.response));
    }
};

export const resetTreasureBoxState = () => async (dispatch) => {
    dispatch(resetTreasureBoxStateSuccess(false));
};

export const resetTreasureBox = () => async (dispatch) => {
    dispatch(resetTreasureBoxSuccess(false));
};

export const { 
    doGetTreasureBoxListSuccess,
    doGetTreasureBoxListFail,

    doGetTreasureBoxSummarySuccess,
    doGetTreasureBoxSummaryFail,

    doGetTreasureBoxDetailSuccess,
    doGetTreasureBoxDetailFail,

    doAddTreasureBoxSuccess,
    doAddTreasureBoxFail,

    doUpdateTreasureBoxSuccess,
    doUpdateTreasureBoxFail,

    resetTreasureBoxStateSuccess,
    resetTreasureBoxSuccess,
} = treasureBoxSlide.actions;

export const getTreasureBoxList = (state) => state.treasureBox?.listData;
export const getTreasureBoxListPage = (state) => state.treasureBox?.page;
export const getTreasureBoxListPageCount = (state) => state.treasureBox?.pageCount;
export const getTreasureBoxSummary = (state) => state.treasureBox?.summaryData;

export const getTreasureBoxDetail = (state) => state.treasureBox?.detailData;
export const getTreasureBoxErrorDetailData = (state) => state.treasureBox?.errorDetailData;

export const getAddTreasureBoxSuccess = (state) => state.treasureBox?.success;
export const getAddTreasureBoxFail = (state) => state.treasureBox?.fail;
export const getAddTreasureBoxResponseData = (state) => state.treasureBox?.responseData;

export default treasureBoxSlide.reducer;
